import { render, staticRenderFns } from "./InformativeCard.vue?vue&type=template&id=121f16d0&scoped=true&"
import script from "./InformativeCard.vue?vue&type=script&lang=js&"
export * from "./InformativeCard.vue?vue&type=script&lang=js&"
import style0 from "./InformativeCard.vue?vue&type=style&index=0&lang=css&"
import style1 from "./InformativeCard.vue?vue&type=style&index=1&id=121f16d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "121f16d0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VDialog,VIcon})
